module.exports = __webpack_public_path__ + "static/media/Regirock_gaussian2.e94971ed.png";